import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Steps } from "@/components/blocks/Steps";
import { ROUTE_DEMO } from "@/lib/brand";

// Zurückhaltender Textlink: erkennbar, aber ohne den Absatz zu zerreißen.
const INLINE_LINK =
  "text-white/80 underline decoration-white/25 underline-offset-4 hover:text-white hover:decoration-brand-orange transition-colors duration-300";

/**
 * Der Weg zur Partnerschaft als kompakte Kurzfassung am Ende der Startseite.
 * Ausführlich und je Zielgruppe zugeschnitten steht der Ablauf auf „Für
 * Vereine“ und „Für Unternehmen“.
 */
const STEPS = [
  {
    no: "01",
    title: "Profil anlegen",
    text: "Vereine und Unternehmen machen ihre Angaben in derselben Struktur.",
  },
  {
    no: "02",
    title: "Zueinander finden",
    text: "Über den MatchScore oder die Filtersuche, von beiden Seiten aus.",
  },
  {
    no: "03",
    title: "Ins Gespräch kommen",
    text: "Im integrierten Chat, direkt bei der zuständigen Person.",
  },
  {
    no: "04",
    title: "Sponsoring einrichten",
    text: "Beim Abschluss festhalten, was vereinbart ist. Beide bestätigen.",
  },
  {
    no: "05",
    title: "Wirkung belegen",
    text: "Was sich messen lässt, läuft automatisch mit. Den Rest trägt der Verein in Sekunden ein.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="ablauf"
      data-testid="manifesto-section"
      className="relative py-24 lg:py-32 border-t border-white/[0.06]"
    >
      <div className="px-6 md:px-10 lg:px-16">
        <Reveal className="max-w-2xl mb-14">
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-brand-orange mb-5">
            Der Weg zur Partnerschaft
          </p>
          <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[0.98]">
            Fünf Schritte durch das{" "}
            <span className="gradient-text">Gate</span>.
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-white/55">
            Vom Profil bis zur Auswertung läuft alles über dieselbe Plattform.
            Im Detail sieht der Weg{" "}
            <Link to="/fuer-vereine" className={INLINE_LINK}>
              für Vereine
            </Link>{" "}
            anders aus als{" "}
            <Link to="/fuer-unternehmen" className={INLINE_LINK}>
              für Unternehmen
            </Link>
            . Die Schritte 04 und 05 könnt ihr{" "}
            <Link to={ROUTE_DEMO} className={INLINE_LINK}>
              in der Demo
            </Link>{" "}
            selbst ausprobieren.
          </p>
        </Reveal>

        <Steps steps={STEPS} />
      </div>
    </section>
  );
};
